<script setup lang="ts">
import { usePaneStore } from '#layers/ui/public';
import WorkspaceChromeSidebarToggle from './WorkspaceChromeSidebarToggle.vue';
import WorkspaceSwitcher from './WorkspaceSwitcher.vue';

const paneStore = usePaneStore();
</script>

<template>
	<div class="flex items-center gap-3 px-3 text-sm font-semibold block-(--primary-header-height)">
		<WorkspaceSwitcher placement="sidebar" />

		<WorkspaceChromeSidebarToggle v-if="paneStore.sidebarVisible" class="ms-auto shrink-0" />
	</div>
</template>
